import React from 'react';
import { useStyles } from './ProgressViewerActionButton.styles';
import { Button, Spinner } from '@fluentui/react-components';

export type ProgressViewerActionButtonProps = {
  label: string;
  isDisabled?: boolean;
  isInProgress?: boolean;
  onClick: () => void;
};

export const ProgressViewerActionButton: React.FC<ProgressViewerActionButtonProps> = ({
  label,
  isDisabled,
  onClick,
  isInProgress,
}) => {
  const styles = useStyles();

  return (
    <Button
      appearance="primary"
      shape="circular"
      className={styles.actionButton}
      onClick={onClick}
      disabled={isDisabled}
      aria-label={label}
      icon={isInProgress ? <Spinner size="tiny" appearance="inverted" /> : undefined}
    >
      {label}
    </Button>
  );
};
